import React, { useEffect, useState } from 'react'

import iconPoolValue from 'Assets/Icons/AdminDashboard/mn9vwcis-68oqs55.png'
import tokenPoolService, { TokenPoolSnapshot } from 'Services/tokenPoolService'
import { CurrencyFormatter, handleError } from 'Helpers'
import fillingStationService from 'Services/fillingStationService'
import investorTokenAssetsService, {
  type InvestorTokenAsset,
} from 'Services/investorTokenAssetsService'
import { Link, useNavigate } from 'react-router-dom'
import DashboardChartsV2 from '../../Components/Dashboard/DashboardChartsV2/DashboardChartsV2'
import './DashboardOverviewV2.scss'
import RecentSignup from '../../Components/Dashboard/DashboardActivityV2/RecentSignup/RecentSignup'
import StationPerformance from '../../Components/Dashboard/DashboardActivityV2/StationPerformance/StationPerformance'
import StationBreakdown from '../../Components/Dashboard/DashboardActivityV2/StationBreakdown'
import DashRecentTransactions from '../../Components/Dashboard/DashboardActivityV2/RecentTransactions/DashRecentTransactions'

export interface RecentInvestment {
  id: string
  accountId: string
  customer: {
    firstName: string
    lastName: string
    msisdn: string
    emailAddress: string
    photo: {
      url: string
    }
  }
  type: string
  flowType: string
  description: string
  paidStatus: string
  amountMajor: number
  currency: string
  walletBalanceMajorBefore: number
  walletBalanceMajorAfter: number
  paymentProcessor: null
  walletType: string
  metadata: {
    transactionNote: string
    investorTokenAssetId: string
  }
  reference: string
  createdAt: string
}
const DashboardOverviewV2: React.FC = () => {
  const navigate = useNavigate()
  const [pool, setPool] = useState<TokenPoolSnapshot | null>(null)

  const fetchPool = async () => {
    await tokenPoolService.get().then(
      (response) => {
        setPool((response?.data?.data ?? null) as TokenPoolSnapshot | null)
      },
      (e) => {
        setPool(null)
        handleError(e)
      },
    )
  }

  const [stationsCount, setStationsCount] = useState<number>(0)
  const fetchStations = async () => {
    await fillingStationService.getAll(1).then(
      (response) => {
        setStationsCount(Number(response?.data.data?.total))
      },
      (e) => {
        setStationsCount(0)
        handleError(e)
      },
    )
  }

  const [tokenCount, setTokenCount] = useState<number>(0)
  const fetchAssets = async () => {
    await investorTokenAssetsService
      .list({
        pageNumber: 1,
        pageSize: 1000,
        sortOrder: 'DESC',
        status: 'ACTIVE',
      })
      .then((response) => {
        setTokenCount(Number(response?.data?.data?.total ?? 0))
      })
  }

  useEffect(() => {
    fetchPool()
    fetchStations()
    fetchAssets()
  }, [])

  return (
    <div className='admin-dashboard-v2 mt-4'>
      <div className='container'>
        <div className='admin-dashboard__greeting'>Welcome back, Admin👋</div>

        <div className='row g-3 g-xl-4'>
          <div className='col-12 col-md-6 col-xl-3'>
            <div
              className='admin-kpi admin-kpi--blue'
              onClick={() => navigate('/boostxpress/dashboard')}
            >
              <div className='admin-kpi__left'>
                <div className='admin-kpi__title'>BoostXpress Users</div>
                <div className='admin-kpi__value'> {Number(pool?.totalTokens)}</div>
                <div className='admin-kpi__meta d-none'>Across {stationsCount} stations</div>
              </div>
              <div className='admin-kpi__icon-wrap'>
                <svg
                  className='admin-kpi__icon'
                  width='38'
                  height='18'
                  viewBox='0 0 38 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M29.4199 5.14106e-05C27.5138 0.00231895 25.67 0.677538 24.2157 1.90596L19.7112 5.69908L22.3227 7.90395L25.8588 4.9143C26.7665 4.15713 27.9115 3.74065 29.095 3.73712H29.3637C30.6893 3.73712 31.9605 4.26209 32.8978 5.19654C33.8352 6.13098 34.3617 7.39837 34.3617 8.71988C34.3617 10.0414 33.8352 11.3088 32.8978 12.2432C31.9605 13.1777 30.6893 13.7026 29.3637 13.7026H29.0888C27.9041 13.6995 26.7583 13.2805 25.8525 12.5192L21.9166 9.18701L18.3305 6.17244L13.2637 1.89973C12.0898 0.910063 10.6566 0.275743 9.13294 0.0716C7.60931 -0.132543 6.05891 0.102007 4.66462 0.747581C3.27034 1.39315 2.09035 2.42282 1.26386 3.7151C0.437365 5.00738 -0.001147 6.50837 5.35865e-05 8.04098V9.39878C-0.00555907 10.9341 0.429841 12.4389 1.25479 13.7354C2.07974 15.0318 3.25975 16.0657 4.65536 16.7149C6.05096 17.3641 7.60381 17.6013 9.13036 17.3986C10.6569 17.196 12.0934 16.5618 13.2699 15.5712L17.7744 11.778L15.1629 9.57317L11.6268 12.5566C10.7158 13.3044 9.57059 13.71 8.39056 13.7026H8.12191C6.79634 13.7026 5.52506 13.1777 4.58774 12.2432C3.65042 11.3088 3.12384 10.0414 3.12384 8.71988C3.12384 7.39837 3.65042 6.13098 4.58774 5.19654C5.52506 4.26209 6.79634 3.73712 8.12191 3.73712H8.3968C9.58151 3.74028 10.7273 4.15925 11.633 4.92053L15.569 8.24652L19.1551 11.2673L24.2157 15.5712C25.3922 16.5618 26.8287 17.196 28.3552 17.3986C29.8818 17.6013 31.4346 17.3641 32.8302 16.7149C34.2258 16.0657 35.4058 15.0318 36.2308 13.7354C37.0557 12.4389 37.4912 10.9341 37.4855 9.39878V8.04098C37.4839 5.9089 36.6336 3.86461 35.1213 2.35701C33.6091 0.849397 31.5585 0.00170099 29.4199 5.14106e-05Z'
                    fill='#002b5c'
                  />
                </svg>
                {/* <img src={iconPoolValue} alt='' className='admin-kpi__icon' /> */}
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6 col-xl-3'>
            <div className='admin-kpi admin-kpi--green'>
              <div className='admin-kpi__left'>
                <div className='admin-kpi__title'>TDLA Investors</div>
                <div className='admin-kpi__value'>{tokenCount}</div>
                <div className='admin-kpi__meta d-none'>120 investors</div>
              </div>
              <div className='admin-kpi__icon-wrap'>
                <svg
                  className='admin-kpi__icon'
                  width='206'
                  height='220'
                  viewBox='0 0 206 220'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M102.644 80.6107V33.144C102.644 19.8892 113.389 9.14404 126.644 9.14404H172.144C185.399 9.14404 196.144 19.8892 196.144 33.1441V83.4107C196.144 96.6655 185.399 107.411 172.144 107.411H93.7393H33.144C19.8892 107.411 9.14404 118.156 9.14404 131.411V186.144C9.14404 199.399 19.8892 210.144 33.144 210.144H78.644C91.8989 210.144 102.644 199.399 102.644 186.144V136.444'
                    stroke='#002B5C'
                    strokeWidth='18.2882'
                  />
                </svg>

                {/* <img src={iconPoolValue} alt='' className='admin-kpi__icon' /> */}
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6 col-xl-3'>
            <div
              className='admin-kpi admin-kpi--purple'
              onClick={() => navigate('/general-overview/tgplus-overview')}
            >
              <div className='admin-kpi__left'>
                <div className='admin-kpi__title'>TG Plus Customers</div>
                <div className='admin-kpi__value'>
                  {CurrencyFormatter(
                    Number(pool?.tokenValueNairaMajor) * Number(pool?.soldTokens ?? 0),
                  )}
                </div>
                <div className='admin-kpi__meta d-none d-none'>93.2% capacity</div>
              </div>
              <div className='admin-kpi__icon-wrap'>
                <img src={iconPoolValue} alt='' className='admin-kpi__icon' />
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6 col-xl-3'>
            <div className='admin-kpi admin-kpi--orange'>
              <div className='admin-kpi__left'>
                <div className='admin-kpi__title'>Boost Customers</div>
                <div className='admin-kpi__value'>{stationsCount}</div>
                <div className='admin-kpi__meta d-none'>40 assigned · 5 unassigned</div>
              </div>
              <div className='admin-kpi__icon-wrap'>
                <svg
                  className='admin-kpi__icon'
                  width='38'
                  height='18'
                  viewBox='0 0 38 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M29.4199 5.14106e-05C27.5138 0.00231895 25.67 0.677538 24.2157 1.90596L19.7112 5.69908L22.3227 7.90395L25.8588 4.9143C26.7665 4.15713 27.9115 3.74065 29.095 3.73712H29.3637C30.6893 3.73712 31.9605 4.26209 32.8978 5.19654C33.8352 6.13098 34.3617 7.39837 34.3617 8.71988C34.3617 10.0414 33.8352 11.3088 32.8978 12.2432C31.9605 13.1777 30.6893 13.7026 29.3637 13.7026H29.0888C27.9041 13.6995 26.7583 13.2805 25.8525 12.5192L21.9166 9.18701L18.3305 6.17244L13.2637 1.89973C12.0898 0.910063 10.6566 0.275743 9.13294 0.0716C7.60931 -0.132543 6.05891 0.102007 4.66462 0.747581C3.27034 1.39315 2.09035 2.42282 1.26386 3.7151C0.437365 5.00738 -0.001147 6.50837 5.35865e-05 8.04098V9.39878C-0.00555907 10.9341 0.429841 12.4389 1.25479 13.7354C2.07974 15.0318 3.25975 16.0657 4.65536 16.7149C6.05096 17.3641 7.60381 17.6013 9.13036 17.3986C10.6569 17.196 12.0934 16.5618 13.2699 15.5712L17.7744 11.778L15.1629 9.57317L11.6268 12.5566C10.7158 13.3044 9.57059 13.71 8.39056 13.7026H8.12191C6.79634 13.7026 5.52506 13.1777 4.58774 12.2432C3.65042 11.3088 3.12384 10.0414 3.12384 8.71988C3.12384 7.39837 3.65042 6.13098 4.58774 5.19654C5.52506 4.26209 6.79634 3.73712 8.12191 3.73712H8.3968C9.58151 3.74028 10.7273 4.15925 11.633 4.92053L15.569 8.24652L19.1551 11.2673L24.2157 15.5712C25.3922 16.5618 26.8287 17.196 28.3552 17.3986C29.8818 17.6013 31.4346 17.3641 32.8302 16.7149C34.2258 16.0657 35.4058 15.0318 36.2308 13.7354C37.0557 12.4389 37.4912 10.9341 37.4855 9.39878V8.04098C37.4839 5.9089 36.6336 3.86461 35.1213 2.35701C33.6091 0.849397 31.5585 0.00170099 29.4199 5.14106e-05Z'
                    fill='white'
                  />
                </svg>

                {/* <img src={iconPoolValue} alt='' className='admin-kpi__icon' /> */}
              </div>
            </div>
          </div>
        </div>

        <div className='row DashboardChartsV2'>
          <div className='g-3 g-xl-4 mt-3 col-12 col-lg-6'>
            <DashboardChartsV2 />
            <div className='DashboardActivityV2 mt-3'>
              <RecentSignup />
            </div>
          </div>

          <div className='DashboardActivityV2 mt-3 col-12 col-lg-6'>
            <StationPerformance />
            <StationBreakdown />
            <DashRecentTransactions />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardOverviewV2
